import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const MultilineColumn = ({ columnKey, columnValue, shouldUseSetInnerHTML })=>{
    const lines = columnValue.map((item, key)=>{
        if (shouldUseSetInnerHTML) {
            return(// eslint-disable-next-line react/no-danger
            /*#__PURE__*/ _jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: item
                },
                children: /*#__PURE__*/ _jsx("br", {})
            }, key));
        }
        return /*#__PURE__*/ _jsxs("span", {
            children: [
                item,
                /*#__PURE__*/ _jsx("br", {})
            ]
        }, key);
    });
    return(// eslint-disable-next-line react/forbid-dom-props
    /*#__PURE__*/ _jsx("td", {
        id: columnKey,
        className: columnKey,
        children: lines
    }));
};
export const SortedTableColumn = ({ columnKey, columnValue, className, tableProps })=>{
    const { spanColumns, setInnerHTMLColumns, multiLineColumns } = tableProps;
    if (!columnValue) {
        return null;
    }
    const columnClassName = `${columnKey} ${className}`;
    // If this flag is set a span tag is added around the content of table data. Default - no span tag added.
    const shouldAddSpanTag = spanColumns ? spanColumns.indexOf(columnKey) >= 0 : false;
    // If this flag is set, we will use dangerouslySetInnerHTML
    const shouldUseSetInnerHTML = setInnerHTMLColumns ? setInnerHTMLColumns.indexOf(columnKey) >= 0 : false;
    // If this flag is set the content of table data can have breaks within it. Default - A single line.
    const shouldShowMultiLine = multiLineColumns ? multiLineColumns.indexOf(columnKey) >= 0 : false;
    if (columnValue instanceof Array && shouldShowMultiLine) {
        return /*#__PURE__*/ _jsx(MultilineColumn, {
            columnKey: columnKey,
            columnValue: columnValue,
            shouldUseSetInnerHTML: shouldUseSetInnerHTML
        });
    } else if (typeof columnValue === 'string' || typeof columnValue === 'number' || typeof columnValue === 'object') {
        if (shouldAddSpanTag) {
            return(// eslint-disable-next-line react/forbid-dom-props
            /*#__PURE__*/ _jsx("td", {
                id: columnKey,
                className: columnClassName,
                children: /*#__PURE__*/ _jsx("span", {
                    children: columnValue
                })
            }));
        } else if (shouldUseSetInnerHTML) {
            return /*#__PURE__*/ _jsx("td", {
                // eslint-disable-next-line react/forbid-dom-props
                id: columnKey,
                className: columnClassName,
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: columnValue
                }
            });
        } else {
            return(// eslint-disable-next-line react/forbid-dom-props
            /*#__PURE__*/ _jsx("td", {
                id: columnKey,
                className: columnClassName,
                children: columnValue
            }));
        }
    }
};
